import { render, staticRenderFns } from "./NetTypeShow.vue?vue&type=template&id=1d775816&"
import script from "./NetTypeShow.vue?vue&type=script&lang=js&"
export * from "./NetTypeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports